import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  AssetHierarchyResponse,
  Site,
} from '../utils/assetHierarchy.types';
import { getAssetHierarchy } from './assetHierarchy.thunk';

interface AssetHierarchyState {
  assetHierarchy: Site[];
  error: string | null;
  loading: boolean;
}

const initialState: AssetHierarchyState = {
  assetHierarchy: [],
  error: null,
  loading: false,
};

const assetHierarchySlice = createSlice({
  name: 'assetHierarchy',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getAssetHierarchy.pending, state => {
        state.error = null;
        state.loading = true;
      })

      .addCase(
        getAssetHierarchy.fulfilled,
        (state, action: PayloadAction<AssetHierarchyResponse>) => {
          state.assetHierarchy = action.payload ? action.payload.sites : [];
          state.loading = false;
        }
      )

      .addCase(getAssetHierarchy.rejected, (state, action) => {
        const payload = action.payload as
          | { message?: string }
          | string
          | undefined;
        state.error =
          (typeof payload === 'object' && payload?.message) ||
          (typeof payload === 'string' ? payload : null) ||
          'Failed to fetch asset hierarchy';
        state.loading = false;
      });
  },
});

// // Export actions for use in components
// export const {

// } = assetHierarchySlice.actions;

// Export reducer for store
export default assetHierarchySlice.reducer;
